import React, { useEffect, useRef, useState } from "react";
import { useMap, TileLayer } from "react-leaflet";
import * as esriV from "esri-leaflet-vector";
import { useGetMapApiKeyQuery } from "../../../actions/configInQuery";

const SatelliteLayer: React.FC = () => {
  const map = useMap();
  const [hasError, setHasError] = useState(false);
  const layerErrored = useRef(false);
  const { data, isError, isLoading } = useGetMapApiKeyQuery();

  useEffect(() => {
    layerErrored.current = false;
  }, [data]);

  useEffect(() => {
    if (isLoading) return;

    if (!data?.arcgis_key || isError) {
      setHasError(true);
      return;
    }

    if (layerErrored.current) return;
    setHasError(false);

    const layer = esriV.vectorBasemapLayer("ArcGIS:Imagery", {
      apiKey: data.arcgis_key,
    });

    layer.on("error", () => {
      layerErrored.current = true;
      map.removeLayer(layer);
      setHasError(true);
    });

    layer.addTo(map);

    return () => {
      map.removeLayer(layer);
    };
  }, [map, data, isError, isLoading]);

  return hasError && !isLoading ? (
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
  ) : null;
};

export default SatelliteLayer;
